import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as IconArrowLeft } from '../../assets/icon/ic_arrow_left.svg';
import { ReactComponent as IconArrowDoubleLeft } from '../../assets/icon/ic_double_arrow_left.svg';
import { ReactComponent as IconArrowRight } from '../../assets/icon/ic_arrow_right.svg';
import { ReactComponent as IconArrowDoubleRight } from '../../assets/icon/ic_double_arrow_right.svg';
import PaginateItem from './components/PaginateItem';
import CustomSelect from '../Select/CustomSelect';
import paginationSizeList from '../../constants/pagination';

const Pagination = ({
  pageRange, currentPage, onPagePress, lastPage, loading, withPaginationSize, size, onSizeChange
}) => {
  const paginateLength = [];
  const getPaginatePage = () => {
    for (let i = currentPage - Math.floor((pageRange) / 2) || 1;
      i <= currentPage + Math.floor(pageRange / 2) + (currentPage === 1 ? 1 : 0);
      i += 1) {
      paginateLength.push(i);
    }
    return paginateLength;
  };

  const onItemClick = (page) => {
    if (page !== currentPage && page > 0 && page <= lastPage && !loading) {
      onPagePress(page);
    }
  };

  return (
    <div className={`flex flex-row ${withPaginationSize ? 'justify-between' : 'justify-end'} w-full`}>
      {withPaginationSize && (
      <div>
        <CustomSelect
          value={[{ label: size, value: size }]}
          options={paginationSizeList}
          onChange={onSizeChange}
          menuPlacement="top"
          controlStyle={{
            border: '1px solid var(--select-option-hover)',
            cursor: 'pointer',
            boxShadow: '0 0 0 1px rgba(65, 90, 119, 0.6)'
          }}
        />
      </div>
      )}
      <div className="flex flex-row items-center justify-center">
        <PaginateItem onClick={() => onItemClick(1)}>
          <IconArrowDoubleLeft className="w-[22px] text-text-second" />
        </PaginateItem>
        <PaginateItem onClick={() => onItemClick(currentPage - 1)}>
          <IconArrowLeft className="w-[22px] text-text-second" />
        </PaginateItem>
        {getPaginatePage().map((page) => page > 0 && page <= lastPage && (
          <PaginateItem
            key={page}
            onClick={() => onItemClick(page)}
            page={page}
            active={page === currentPage}
          >
            {page}
          </PaginateItem>
        ))}
        <PaginateItem onClick={() => onItemClick(currentPage + 1)}>
          <IconArrowRight className="w-[22px] text-text-second" />
        </PaginateItem>
        <PaginateItem onClick={() => onItemClick(lastPage)}>
          <IconArrowDoubleRight className="w-[22px] text-text-second" />
        </PaginateItem>
      </div>
    </div>

  );
};

Pagination.propTypes = {
  pageRange: PropTypes.number,
  currentPage: PropTypes.number,
  lastPage: PropTypes.number,
  size: PropTypes.number,
  onPagePress: PropTypes.func,
  onSizeChange: PropTypes.func,
  loading: PropTypes.bool,
  withPaginationSize: PropTypes.bool
};

Pagination.defaultProps = {
  pageRange: 3,
  currentPage: 2,
  lastPage: 1,
  size: 25,
  onPagePress: () => {},
  onSizeChange: () => {},
  loading: false,
  withPaginationSize: false,
};

export default Pagination;
